<template>
  <div>
    <div
      class="flex justify-center items-center w-full h-[95vh] text-center block lg:hidden"
    >
      <h3 class="text-lg font-medium px-4">
        {{ $t("error.chat_view") }}
        <div>
          <router-link to="/dashboard" class="router-link">
            <md-button class="btn md-warning"
              >{{ $t("error.back_to_dashboard") }}
            </md-button>
          </router-link>
        </div>
      </h3>
    </div>
    <md-card class="mt-0 chat-container rounded-tl-2xl hidden lg:block">
      <md-card-content class="h-full py-0 pl-0 ">
        <div class="md-layout h-full pl-0 rounded-tl-2xl">
          <div
            class="w-[390px] h-full border-r px-0 bg-[#f7f7f7] rounded-tl-2xl"
          >
            <side-bar @clearIframe="clearIframe" ref="sidebarRefs"></side-bar>
          </div>
          <div v-if="userHeader" class="md-layout-item px-0">
            <iframe
              v-if="activeIframe"
              class="h-full w-full"
              :src="sourceRocketChat + currentPath"
              allow="autoplay"
            ></iframe>
          </div>
          <div
            v-else
            class="flex items-center justify-center mx-auto text-center"
          >
            <img
              src="https://img.freepik.com/premium-vector/illustration-vector-graphic-cartoon-character-chat_516790-225.jpg?w=400"
              alt=""
            />
          </div>
          <iframe
            class="w-[0] h-[0] hidden"
            id="rcChannel"
            :src="domainRocketChat"
            allow="autoplay"
          ></iframe>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import SideBar from "./Sidebar";
import { checkLoginExpired } from "@/pages/ChatRoom/Sidebar/Components/helpers";
import axios from "axios";
import { mapGetters, mapMutations } from "vuex";
import { initLoader, Message } from "@/helpers/utils";
import { dashboard_router_name } from "@/routes/routes";

export default {
  components: { SideBar },
  data() {
    return {
      isLoading: null,
      isLoginIframe: false,
      activeIframe: false,
      currentPath: "",
      chatId: "",
      userHeader: null,
      componentKey: null,
      authToken: "",
      sourceRocketChat: process.env.VUE_APP_ROCKET_CHAT_URL,
      domainRocketChat: process.env.VUE_APP_ROCKET_CHAT_URL,
      passwordDefault: process.env.VUE_APP_ROCKET_CHAT_DEFAULT_PASSWORD,
      // usernameSupporter: process.env.VUE_APP_SUPPORTER_USERNAME,
      loader: null
    };
  },
  computed: {
    ...mapGetters("user", {
      userInfo: "info"
    }),
    ...mapGetters("chat", {
      isLoginIframeLocal: "isLoggedInIframe"
    })
  },
  created() {
    checkLoginExpired();
  },
  methods: {
    ...mapMutations("chat", ["setStatusLoginIframe"]),
    clearIframe() {
      this.userHeader = null;
    },
    routerToRoomChat(room, isGroup) {
      let intervalTimer;
      if (this.isLoginIframe) {
        this.redirectLinkIframe(room, isGroup);
        return;
      }
      const self = this;
      intervalTimer = setInterval(function() {
        if (self.isLoginIframe) {
          self.redirectLinkIframe(room, isGroup);
          clearInterval(intervalTimer);
        }
      }, 100);
    },
    redirectLinkIframe(room, isGroup) {
      this.userHeader = room;
      this.chatId = room.room_id;
      // this.$refs.sidebarRefs.roomChatSupporterId = null;
      const groupName = room?.name?.replaceAll(" ", "-");
      const subPath = isGroup
        ? `/group/${groupName}`
        : `/direct/${room.room_id}`;
      this.currentPath = subPath + "?layout=embedded";
      this.activeIframe = true;
    },
    loginIframeRocketChat() {
      document.getElementById("rcChannel").contentWindow.postMessage(
        {
          event: "login-with-token",
          loginToken: this.authToken
        },
        this.domainRocketChat
      );
    },
    clearRoomChat() {
      this.chatId = "";
      this.userHeader = null;
    },
    /*setLoginUser(isModeSupporter) {
     let userLoginRequest = {
     username: this.userInfo.username,
     password: this.passwordDefault
     };
     let letSupporterLoginRequest = {
     username: this.usernameSupporter,
     password: this.passwordDefault
     };
     return isModeSupporter ? letSupporterLoginRequest : userLoginRequest;
     },*/
    async loginRocketChat() {
      let loginRequest = {
        username: this.userInfo.username.replaceAll(" ", "-"),
        password: this.passwordDefault
      };
      axios
        .post(this.domainRocketChat + "/api/v1/login", loginRequest, {
          headers: { "Content-Type": "application/json" }
        })
        .then(response => {
          this.authToken = response.data.data.authToken;
          this.loginIframeRocketChat();
        })
        .catch(err => {
          console.log("login fail: ", err);
          this.setStatusLoginIframe(null);
          Message.error(this.$t("chat_room.login_fail"));
          this.isLoginIframe = null;
          this.loader && this.loader.hide();
          this.$router.push({ name: dashboard_router_name });
        });
    }
  },
  mounted() {
    this.isLoginIframe = this.isLoginIframeLocal;
    if (this.isLoginIframe) return;
    let myIframe = document.getElementById("rcChannel");
    const self = this;
    self.loader = initLoader();
    myIframe.addEventListener("load", function() {
      setTimeout(() => {
        self.loginIframeRocketChat();
        self.loader.hide();
        self.setStatusLoginIframe(true);
        self.isLoginIframe = true;
      }, 2000);
    });
    myIframe.src = this.domainRocketChat;
  },
  provide() {
    return {
      routerToRoomChat: this.routerToRoomChat,
      loginRocketChat: this.loginRocketChat,
      clearRoomChat: this.clearRoomChat
    };
  }
};
</script>

<style lang="scss" scoped>
.border-sidebar {
  border-right: 1px solid #d0d0d0;
}

.chat-container {
  position: fixed;
  width: calc(100vw - 110px);
  height: calc(100vh - 90px) !important;
}
</style>
